import { CarOutlined } from '@ant-design/icons';
import { Space, Typography } from 'antd';
import { COLORS } from '@/config/colors';

const { Text } = Typography;

type TitleProps = {
  collapsed?: boolean;
};

export const Title = ({ collapsed }: TitleProps): React.JSX.Element => {
  return (
    <Space
      align="center"
      style={{
        display: 'flex',
        justifyContent: collapsed ? 'center' : 'flex-start',
        transition: 'all 0.2s',
      }}
    >
      <CarOutlined
        style={{
          fontSize: collapsed ? 24 : 28,
          color: COLORS.brand.primary,
          transition: 'all 0.2s',
        }}
      />
      {!collapsed && (
        <Text
          strong
          style={{
            fontSize: 16,
            color: 'var(--sider-text)',
            whiteSpace: 'nowrap',
          }}
        >
          ERP System
        </Text>
      )}
    </Space>
  );
};
